var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpottedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.1802 89.6378C69.933 89.6378 89.9991 69.5717 89.9991 44.8189C89.9991 20.0661 69.933 0 45.1802 0C20.4274 0 0.361328 20.0661 0.361328 44.8189C0.361328 69.5717 20.4274 89.6378 45.1802 89.6378Z",
    fill: "#4D4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6025 42.4796C32.2393 40.4324 32.2393 37.1423 35.6025 35.0951C38.9658 33.0479 44.5224 29.7578 47.8857 27.7106C51.2489 25.6634 54.0273 27.345 54.0273 31.3663C54.0273 35.3876 54.0273 42.0409 54.0273 46.0622C54.0273 50.0835 51.2489 51.7651 47.8857 49.7179C44.5224 47.6707 38.9658 44.4537 35.6025 42.4796Z",
    fill: "url(#paint0_linear_1304_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7587 46.9396C58.122 48.9868 58.122 52.2769 54.7587 54.3241C51.3955 56.3713 45.8388 59.6614 42.4756 61.7086C39.1123 63.7558 36.334 62.0742 36.334 58.0529C36.334 54.0317 36.334 47.3783 36.334 43.357C36.334 39.3357 39.1123 37.6541 42.4756 39.7013C45.8388 41.7485 51.3955 44.8924 54.7587 46.9396Z",
    fill: "url(#paint1_linear_1304_3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    height: 1,
    width: 1,
    fill: "red"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1304_3",
    transform: "translate(0 -0.690191) scale(0.000421941 0.000669587)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1304_3",
    x1: 41.8293,
    y1: 31.6271,
    x2: 52.466,
    y2: 50.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8252,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1304_3",
    x1: 48.5361,
    y1: 57.7616,
    x2: 37.8994,
    y2: 38.9182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8252,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpottedLogo);
export default __webpack_public_path__ + "static/media/spotted_logo.a6d68c88b0e8cf34d384527eb9198720.svg";
export { ForwardRef as ReactComponent };